import { baseurl } from "../../../baseurl";

export const craveImg = (url) => {
  if (!url) return url;
  const marker = "/uploads/";
  const i = url.indexOf(marker);
  if (i === -1) return url;
  const file = url.slice(i + marker.length);
  return `${baseurl}/loyaltyImg/${file}`;
};
